import React from 'react'
import { useTranslation } from 'react-i18next'

// MUI Imports
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material'

const FirmSelectionConfirmDialog = ({
  open,
  onConfirm,
  onCancel
}) => {
  const { t } = useTranslation()

  return (
    <Dialog
      open={open}
      onClose={onCancel}
    >
      <DialogTitle>
        {t('mailTemplate.wizard.firmSelectionConfirm.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('mailTemplate.wizard.firmSelectionConfirm.message')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          {t('mailTemplate.wizard.firmSelectionConfirm.cancel')}
        </Button>
        <Button onClick={onConfirm} color="primary" variant="contained" autoFocus>
          {t('mailTemplate.wizard.firmSelectionConfirm.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default FirmSelectionConfirmDialog
